import { Roles } from "../contexts/authContext";
import { ExtendedUserPermissions, FunctionTypes, PortalGroup, RoleDefinition, UseCase } from "../contexts/permissionsContext";
import { getRoleDefinitions, getUserExtendedPermissions } from "../services/administrationService/administrationService";
import { convertUserObjectCategoriesToEnum } from "./permissionsHelper";

export const defaultFunctionPermissions = () => {
    var fPerms: FunctionTypes = {
        onlineFunction: { active: false, useCaseCode: "PU.SOPO-P.001" }, // Przejdź do trybu online                                               (PU.SOPO-P.001)
        loginFunction: { active: false, useCaseCode: "PU.SOPO-P.002" }, // Wyświetl okno logowania do systemu                                     (PU.SOPO-P.002)
        userNotifications: { active: false, useCaseCode: "PU.SOPO-P.004" }, // Wyświetl komunikaty dla użytkownika                                (PU.SOPO-P.004)
        offlineFunction: { active: false, useCaseCode: "PU.SOPO-P.005" }, // Przejdź do trybu offline                                             (PU.SOPO-P.005)
        processN: { active: false, useCaseCode: "PU.SOPO-P.009" }, // Dodaj nowe osuwisko / teren zagrożony (proces N)                            (PU.SOPO-P.009)
        addGeometry: { active: false, useCaseCode: "PU.SOPO-P.010" }, // Dodaj geometrię do KR                                                    (PU.SOPO-P.010)
        processA: { active: false, useCaseCode: "PU.SOPO-P.011" }, // Aktualizuj osuwisko / teren zagrożony (proces A)                            (PU.SOPO-P.011)
        browseDataBase: { active: false, useCaseCode: "PU.SOPO-P.016" }, // Przeglądaj wszystkie KR w bazie głównej                               (PU.SOPO-P.016)
        verifyKR: { active: false, useCaseCode: "PU.SOPO-P.019" }, // Weryfikuj KR                                                                (PU.SOPO-P.019)
        browseUserKRPOWaitingTab: { active: false, useCaseCode: "PU.SOPO-P.020" }, // Przeglądaj przypisane KR/PO w poczekalni                    (PU.SOPO-P.020)
        editCollectivelyKR: { active: false, useCaseCode: "PU.SOPO-P.021" }, // Edytuj zbiorczo KR                                                (PU.SOPO-P.021)
        assignVerifier: { active: false, useCaseCode: "PU.SOPO-P.022" }, // Przypisz weryfikatora do KR                                           (PU.SOPO-P.022)
        assignEditor: { active: false, useCaseCode: "PU.SOPO-P.023" }, // Przypisz edytora do KR                                                  (PU.SOPO-P.023)
        cancelEditTaskProcessOAndK: { active: false, useCaseCode: "PU.SOPO-P.024" }, // Anuluj zadanie edycji (proces O, K)                       (PU.SOPO-P.024)
        processO: { active: false, useCaseCode: "PU.SOPO-P.028" }, // Dodaj nową KRO/KRTZ (proces O)                                              (PU.SOPO-P.028)   
        processK: { active: false, useCaseCode: "PU.SOPO-P.029" }, // Przygotuj KR do edycji (proces K)                                           (PU.SOPO-P.029)
        downloadKRPOToEdit: { active: false, useCaseCode: "PU.SOPO-P.030" }, // Pobierz KR/PO na komputer osobisty (do edycji)                    (PU.SOPO-P.030)
        returnKRPO: { active: false, useCaseCode: "PU.SOPO-P.032" }, // Zwróć KR/PO do poczekalni                                                 (PU.SOPO-P.032)
        updateOfDataBase: { active: false, useCaseCode: "PU.SOPO-P.033" }, // Aktualizacja bazy głównej                                           (PU.SOPO-P.033)  
        sendNotifications: { active: false, useCaseCode: "PU.SOPO-P.034" }, // Wyślij powiadomienia                                               (PU.SOPO-P.034) 
        userConfig: { active: false, useCaseCode: "PU.SOPO-P.036" }, // Ustaw opcje użytkownika                                                   (PU.SOPO-P.036)
        runAutomaticVerification: { active: false, useCaseCode: "PU.SOPO-P.037" }, // Uruchom weryfikację automatyczną                            (PU.SOPO-P.037)
        sendMessages: { active: false, useCaseCode: "PU.SOPO-P.039" }, // Wyślij wiadomość do użytkownika                                         (PU.SOPO-P.039)                  
        cancelProcessAAndN: { active: false, useCaseCode: "PU.SOPO-P.041" }, // Anuluj dodanie/aktualizację obiektu (proces N,A)                  (PU.SOPO-P.041)
        deleteKRAndRelativeObjects: { active: false, useCaseCode: "PU.SOPO-P.042" }, // Kasuj KR i związane obiekty                               (PU.SOPO-P.042)
        downloadKRForVerification: { active: false, useCaseCode: "PU.SOPO-P.044" }, // Pobierz KR na komputer osobisty (do weryfikacji)           (PU.SOPO-P.044)
        EditPO: { active: false, useCaseCode: "PU.SOPO-P.045" }, // Edytuj PO                                                                     (PU.SOPO-P.045)
        EditKR: { active: false, useCaseCode: "PU.SOPO-P.046" }, // Edytuj KR                                                                     (PU.SOPO-P.046)
        browseKRPOInLocalBase: { active: false, useCaseCode: "PU.SOPO-P.047" }, // Przeglądaj pobrane KR/PO w bazie lokalnej                      (PU.SOPO-P.047)
        browseAllKRPOWaitingTab: { active: false, useCaseCode: "PU.SOPO-P.049" }, // Przeglądaj wszystkie KR/PO w poczekalni                      (PU.SOPO-P.049)
        addPO: { active: false, useCaseCode: "PU.SOPO-P.061" }, // Dodaj protokół obserwacji                                                      (PU.SOPO-P.061)
        correctPO: { active: false, useCaseCode: "PU.SOPO-P.063" }, // Koryguj protokół obserwacji                                                (PU.SOPO-P.063)
        configureNotifications: { active: false, useCaseCode: "PU.SOPO-P.070" }, // Konfiguruj powiadomienia                                      (PU.SOPO-P.070)
        proposeNewDictValue: { active: false, useCaseCode: "PU.SOPO-P.071" }, // Zgłoś propozycję nowej wartości słownikowej                      (PU.SOPO-P.071)
        editDicts: { active: false, useCaseCode: "PU.SOPO-P.072" }, // Edytuj słowniki                                                            (PU.SOPO-P.072)
        acceptRejectDictProposals: { active: false, useCaseCode: "PU.SOPO-P.073" }, // Zatwierdź lub odrzuć propozycję dodania pozycji słownika   (PU.SOPO-P.073)
        configurePermissions: { active: false, useCaseCode: "PU.SOPO-P.074" }, // Zarządzaj uprawnieniami                                         (PU.SOPO-P.074) 
        spacialAnalyses: { active: false, useCaseCode: "PU.SOPO-P.075" }, // Analizy przestrzenne                                                 (PU.SOPO-P.075)                                                    
        showObjGeomOnMap: { active: false, useCaseCode: "PU.SOPO-P.076" }, // Wyświetl geometrię obiektu na mapie                                 (PU.SOPO-P.076)
        pointObjOnMap: { active: false, useCaseCode: "PU.SOPO-P.077" }, // Wskaż obiekt na mapie                                                  (PU.SOPO-P.077)

        
        markKRComplete: { active: false, useCaseCode: "" }, // Oznacz KR 'Kompletna'
        markKRToBeCorrected: { active: false, useCaseCode: "" }, // Oznacz KR 'Do poprawy'
        markKRAccepted: { active: false, useCaseCode: "" }, // Oznacz KR 'Zatwierdzona'
        markPOAccepted: { active: false, useCaseCode: "" }, // Oznacz PO 'Zatwierdzona'
        markKRNoGeom: { active: false, useCaseCode: "" }, // Oznacz KR 'Oczekuje na geometrię'          
    }
    return fPerms;
}

export const defaultExtendedPermissions = () => {
    var extPerms: ExtendedUserPermissions = {
        userObjectCategories: [],
        userPowiaty: [],
        userGminy: [],
        success: false
    };
    return extPerms;
}

export const UserIdToExtendedPermissions = (userId: string, apiBase: string) => {
    var extPerms = defaultExtendedPermissions();

    return new Promise((resolve) => {
        getUserExtendedPermissions(apiBase, userId, false)
        .then((res: any) => {
            var userTeryts = res.userTeryts.map((item: any) => item.teryt);  
            userTeryts.forEach((item: string) => {
                if (item.length === 4) extPerms.userPowiaty!.push(item);
                else extPerms.userGminy!.push(item);
            })           
            extPerms.userObjectCategories = convertUserObjectCategoriesToEnum(res.userObjectCategories);
            extPerms.success = true;
            resolve(extPerms);
        })
        .catch(() => {
            resolve(defaultExtendedPermissions());
        }) 
    })
}

const RolesToPermissions = (roles: string[], apiBase: string) => {       
    var fPerms = defaultFunctionPermissions();

    return new Promise((resolve) => {
        getRoleDefinitions(apiBase)
        .then((res: any) => {
            var useCases: UseCase[] = res.useCases;
            var portalGroups: PortalGroup[] = res.portalGroups;
            var roleDefinitions: RoleDefinition[] = res.roleDefinitions;
            
            // Get user portal groups (roles)
            var userPortalGroups = portalGroups.filter(item => roles.includes(item.nazwa));

            // Get definitions for user portal groups
            var userDefinitions: RoleDefinition[] = [];
            userPortalGroups.forEach(item => {
                var definitionsForGroup = roleDefinitions.filter(elem => elem.portaL_GRUPA_ID === item.id);
                userDefinitions.push(...definitionsForGroup)
            });

            // Get & save use cases available for user
            useCases.forEach(item => {
                if (userDefinitions.some(elem => elem.przypadeK_UZYCIA_ID === item.id)) {
                    var attr = Object.keys(fPerms).find(key => fPerms[key as keyof FunctionTypes].useCaseCode === item.koD_PU);
                    if (attr) fPerms[attr as keyof FunctionTypes].active = true;
                }
            });
            
            // Set state change permissions
            if (roles.includes(Roles.PwaEditorExtended)) {
                fPerms.markKRComplete.active = true;
                fPerms.markPOAccepted.active = true;
            }

            if (roles.includes(Roles.PwaEditor)) {
                fPerms.markKRComplete.active = true;
                fPerms.markPOAccepted.active = true;
            }

            if (roles.includes(Roles.PwaVerificator)) {
                fPerms.markKRToBeCorrected.active = true;
                fPerms.markKRAccepted.active = true;
            } 
            resolve({ definitions: res, permissions: fPerms});
        })
        .catch((err: any) => {
            resolve({ definitions: null, permissions: defaultFunctionPermissions()});
        }) 
    })   
}

export const offlineModePermissions = () => {
    var fPerms = defaultFunctionPermissions();

    fPerms.onlineFunction.active = true;
    fPerms.proposeNewDictValue.active = true;
    fPerms.verifyKR.active = true;
    fPerms.browseUserKRPOWaitingTab.active = true;
    fPerms.editCollectivelyKR.active = true;
    fPerms.runAutomaticVerification.active = true;
    fPerms.EditPO.active = true;
    fPerms.EditKR.active = true;
    fPerms.browseKRPOInLocalBase.active = true;
    fPerms.sendMessages.active = true;
    
    return fPerms;
}

export default RolesToPermissions;